import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";
import mergeDeep from "../util/mergeDeep";

export default function bovenLokaliteitPerInfrastructuurReducer(state = initialState.bovenLokaliteitPerInfrastructuur, action) {
	switch (action.type) {
		case types.BOVEN_LOKALITEIT_PER_INFRASTRUCTUUR_LOADED: {
			return Object.assign({},
				state,
				{
					item: action.body.item,
					documenten: action.body.documenten,
					isLoaded: true,
					errors: action.body.errors,
					hasValidationErrors: action.body.hasValidationErrors,
					isSaved: action.body.isSaved,
					fileSessionStarted: action.body.fileSessionStarted
				});
		}


		case types.BOVEN_LOKALITEIT_PER_INFRASTRUCTUUR_SAVED: {
			return Object.assign({},
				state,
				{
					item: action.body.item,
					errors: action.body.errors,
					hasValidationErrors: action.body.hasValidationErrors
				});
		}

		case types.BOVEN_LOKALITEIT_PER_INFRASTRUCTUUR_CACHE_SAVED: {
			let stateToUpdate = mergeDeep({}, state);

			if (stateToUpdate.item != null) {
				let items = stateToUpdate.item.sportinfrastructurenOpKaart;
				let newItems = [...items.filter(x => x.id != action.body.item.id), action.body.item];

				stateToUpdate.item.sportinfrastructurenInDeBuurt = newItems;
				stateToUpdate.item.sportinfrastructurenOpKaart = newItems;
			}
			stateToUpdate.documenten = action.body.documenten;
			stateToUpdate.isSaved = action.body.isSaved;
			stateToUpdate.fileSessionStarted = action.body.fileSessionStarted;

			return stateToUpdate;
		}

		case types.BOVEN_LOKALITEIT_PER_INFRASTRUCTUUR_VALIDATED: {
			return Object.assign({}, state,
				{
					infrastructuurInDeBuurtErrors: action.body.errors
				});
		}

		case types.BOVEN_LOKALITEIT_UNLOADED: {
			let stateToUpdate = mergeDeep({}, state);
			stateToUpdate.isLoaded = false;
			return stateToUpdate;
		}

		default:
			return state;
	}
}
